angular.module('TetherApp').controller('ListenerParticipantController', [
    function () {
        let self = this;

        self.errors = [];
        self.rules = [];
        self.ruleKey = '';
        self.ruleValue = '';

        // Add rule
        self.addRule = function() {
            // Empty previous errors
            self.errors = [];

            // Rule key not set, show error
            if (! self.ruleKey) {
                self.errors.push('Rule key not set');
            }

            // Rule value not set default to empty string
            if (! self.ruleValue) {
                self.ruleValue = '';
            }

            // No errors present, add it to the rules
            if (self.errors.length == 0) {
                self.rules.push({
                    key: self.ruleKey.trim(),       // remove white space
                    value: self.ruleValue.trim()    // remove white space
                });
            }
        };

        // Remove rule at index
        self.removeRule = function(index) {
            self.rules.splice(index, 1);
        };
    }
]);
